import type { FC } from 'react';

import { useSelector } from 'react-redux';

import { ProductSwitcher } from 'components/new-navigation/product-switcher/ProductSwitcher';
import { Right } from 'constants/right';
import { anyToBoolean, type BooleanNumericFlag } from 'helpers/boolean';
import { getConfig } from 'helpers/config';
import { useFetchFeatures } from 'hooks/api/feature-control/use-fetch-features';
import { useLicenseProperty } from 'hooks/connectivity/configuration-api/properties/use-license-property';
import { useParamSelector } from 'hooks/use-param-selector';
import { selectIsDisableNativeTicketsExperiment } from 'store/entities/experiments/selectors';
import { hasRight } from 'store/features/session/selectors';

import { getTopNavigationIds } from '../configuration';
import { ChatbotItem } from '../items/ChatbotItem';
import { HelpDeskItem } from '../items/HelpDeskItem';
import { NavigationItem } from '../items/navigation-item/NavigationItem';

export const TopNavigation: FC = () => {
  const { data } = useFetchFeatures();
  const { data: helpDeskReplaceTickets } = useLicenseProperty<BooleanNumericFlag>(
    getConfig().accountsClientId,
    'helpdesk.replace_tickets',
  );
  const helpDeskReplacedTickets = anyToBoolean(helpDeskReplaceTickets);
  const tickets = {
    replaced: helpDeskReplacedTickets,
    disabled: useSelector(selectIsDisableNativeTicketsExperiment),
  };
  const ids = getTopNavigationIds({
    shouldShowTickets: !tickets.replaced && !tickets.disabled,
    shouldShowTeam: useParamSelector(hasRight, Right.AgentsSectionAccess),
  });

  return (
    <>
      {data.productSwitcher && <ProductSwitcher />}
      {ids.map((id) => (
        <NavigationItem key={id} id={id} />
      ))}
      <ChatbotItem />
      <HelpDeskItem />
    </>
  );
};
